import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { EmailTemplateService } from 'src/app/private/services/email-template.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { CreateEmailTemplateComponent } from "../../components/email-template/create-email-template/create-email-template.component";
import { PreviewEmailTemplateComponent } from "../../components/email-template/preview-email-template/preview-email-template.component";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-email-template',
  imports: [ToolBarComponent, SharedModule, CreateEmailTemplateComponent, PreviewEmailTemplateComponent],
  templateUrl: './email-template.component.html',
  styleUrl: './email-template.component.scss'
})
export class EmailTemplateComponent {

  isAddTemplate: boolean = false;
  isEditTemplate: boolean = false;
  isPreview: boolean = false;
  isDeleteTemplate: boolean = false;

  templateData: any[] = [];
  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  loading: boolean = false;
  selectedTemplates: any[] = [];

  displayedColumns: any[] = [];
  templateToEdit: any = {};

  processedData: any;

  btnLoading: boolean = false;

  templateActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Template',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditTemplate = true;
          }
        },
        {
          label: 'Preview Template',
          icon: 'pi pi-fw pi-eye',
          command: () => {
            this.isPreview = true;
            this.processedData = this.sanitizer.bypassSecurityTrustHtml(this.templateToEdit.template_body);
          }
        },
        {
          label: 'Delete Template',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteTemplate = true;
          }
        }
      ]
    }
  ]



  constructor(
    private api: EmailTemplateService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.setDisplayColumns();
  }


  setDisplayColumns() {
    this.displayedColumns.push({ field: 'template_name', header: 'Template Name', type: 'template_name' });
    this.displayedColumns.push({ field: 'template_category', header: 'Template Category', type: 'template_category' });
    this.displayedColumns.push({ field: 'status', header: 'Status', type: 'status' });
    this.displayedColumns.push({ field: 'action', header: 'Actions', type: 'actions' });
  }



  loadData(event: any,) {

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;


    const body = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId()
      },
      "page": page,
      "limit": size,
    }



    this.loading = true;
    this.api.getAllEmailTemplate(body).subscribe({
      next: (data) => {
        this.templateData = data.rows
        this.totalRecords = data.count;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  reloadTable() {
    this.loadData({ first: 0, rows: this.rows });
  }


  setTemplateEditData(template: any) {
    this.templateToEdit = template;
  }

  handleDelete() {

    this.btnLoading = true;

    const payload = {
      template_id: this.templateToEdit.template_id
    }

    this.api.deleteTemplate(payload).subscribe((response: any) => {
      if (response) {
        this.btnLoading = false;
        this.isDeleteTemplate = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Template deleted successfully' });
        this.reloadTable();
      }
    },
      (error: any) => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete template' });
      });
  }



}
